var VIEW_ALL_ORDERS_LINK = 'https://admin.microsoft.com/Adminportal/Home#/subscriptions/apps';

export { VIEW_ALL_ORDERS_LINK };
